// extracted by mini-css-extract-plugin
export var locationCard = "_h3-0";